import axios, { AxiosResponse } from 'axios';
import { FetchLoungesDetails } from '../redux/lounges/slice';
import { Lounge } from '../redux/lounges/types';
import { GET_BASE_URL } from '../constants/apiEndpoints';
import { LOUNGE_GET_TIMEOUT_MS } from '../utils/loungeRequest';
import { buildLoungeAuthHeaders } from '../utils/loungeAuthHeader';
export const getAllLoungeDetailApi = async ({
  LoungeId,
}: FetchLoungesDetails) => {
  const responseBody = (response: AxiosResponse) => response.data;
  const token = localStorage.getItem('token');
  const apiEndpoint = GET_BASE_URL + '/api/v1/postdetail/' + LoungeId;
  const { data } = await axios
    .get<Lounge[]>(`${apiEndpoint}`, {
      headers: {
        ...buildLoungeAuthHeaders(token),
      },
      timeout: LOUNGE_GET_TIMEOUT_MS,
    })
    .then(responseBody);

  return data;
};
